import { FEATURE_FLAGS } from '../../constants/featureFlags';
import { logSessionInfo } from '../../services/logger';

/**
 * Determines if the 4-minute timer downlevel feature is enabled.
 * 
 * @returns {boolean} True if the feature is enabled
 */
export function isDownlevelOnTimerEnabled() {
  return FEATURE_FLAGS.ENABLE_ORF_4MIN_TIMER_DOWNLEVEL;
}

/**
 * Handles the assessment timer expiry for ORF passages.
 * 
 * When the 4-minute timer expires:
 * - If the feature flag is enabled, trigger a downlevel (same as the 60-second relevel timer)
 * - The reLevel function will handle grade decrement or prereader exit if already at kindergarten
 * - If the feature flag is disabled, fall back to the existing testTimeExpired behavior
 * 
 * @param {Object} params
 * @param {Function} params.reLevel - Callback to trigger downleveling (decrements grade or exits as prereader at K)
 * @param {Function} params.setTestTimeExpired - Callback to set testTimeExpired state (legacy behavior)
 * @param {number} params.currentGradeLevel - Current student grade level for logging
 */
export function handleAssessmentTimerExpiry({
  reLevel,
  setTestTimeExpired,
  currentGradeLevel,
}) {
  if (isDownlevelOnTimerEnabled()) {
    if (typeof reLevel !== 'function') {
      logSessionInfo('downlevel_error', {
        src: 'assessmentTimer',
        reason: 'reLevel_not_a_function',
        currentGradeLevel,
      });
      if (typeof setTestTimeExpired === 'function') {
        setTestTimeExpired();
      }
      return;
    }
    logSessionInfo('downlevel', {
      src: 'assessmentTimer',
      reason: 'story_not_completed_in_4min',
      currentGradeLevel,
    });
    reLevel('long_pause');
  } else if (typeof setTestTimeExpired === 'function') {
    setTestTimeExpired();
  }
}
